/**
 * Chip de estado en tinte claro.
 *
 * NO uses <Badge color="success"> de reactstrap: es sólido y va contra
 * el diseño. Este componente reemplaza los Badge de order.columns.js,
 * user.columns.js, InfluencerBonusColumns.js y LoyaltyColumns.js.
 */
export const StatusChip = ({ tone = 'neutral', icon, children, sm = false }) => (
  <span className={`ui-chip ui-chip--${tone}${sm ? ' ui-chip--sm' : ''}`}>
    {icon && <i className={icon} />}
    {children}
  </span>
);

export default StatusChip;
